import api from './api';
import { ClusterList } from './clusterStudyService';
import { DescriptionList } from './clusterStudyAnalysisService';
const base = '/api/semantic-drafts';
export const semanticDraftApi = {
  clusters: async (study: string, params: Record<string, string | number>, signal?: AbortSignal) => (await api.get<ClusterList>(`${base}/${study}/clusters`, { params, signal, timeout: 60000 })).data,
  descriptions: async (study: string, cluster: string, page: number, signal?: AbortSignal) => (await api.get<DescriptionList>(`${base}/${study}/clusters/${cluster}/descriptions`, { params: { page, limit: 10 }, signal, timeout: 20000 })).data
};
